import Box from '@mui/material/Box'
import { FC } from 'react'
import { GRAY_500 } from 'constants/styling/theme'

interface Props {
  /** Dot color. */
  color?: string
  /** Dot diameter. */
  size?: string
}

/** Animated "…is typing" indicator — three dots bouncing in sequence (WhatsApp/Messenger style). */
export const TypingDots: FC<Props> = ({ color = GRAY_500, size = '0.6rem' }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.3rem',
      '@keyframes chat-typing-bounce': {
        '0%, 80%, 100%': { transform: 'translateY(0)', opacity: 0.35 },
        '40%': { transform: 'translateY(-0.3rem)', opacity: 1 },
      },
    }}
  >
    {[0, 1, 2].map((index) => (
      <Box
        key={index}
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: color,
          animation: 'chat-typing-bounce 1.2s ease-in-out infinite',
          animationDelay: `${index * 0.16}s`,
        }}
      />
    ))}
  </Box>
)
